<template>
  <div class="list-view">

    <div v-if="notice" :class="['notice-list', { news: currentMenu === 'news' }]">
      <div class="item">
        <router-link :to="{name: 'fansDetail', params: notice.detail}">
          <img v-if="notice.thumbnail" :src="notice.thumbnail" :alt="notice.subject" @error="replaceByDefaultImg">
          <div v-else class="img-empty"></div>
          <ul>
            <li class="title">{{ notice.subject }}</li>
            <li class="date">{{ notice.regDate }}</li>
            <li class="desc" v-html="notice.content"></li>
          </ul>
        </router-link>
      </div>
    </div>

    <div v-if="list.length" class="grid-list">
      <div v-for="(item, index) in list" :key="index" class="item">
        <router-link :to="{name: 'fansDetail', params: item.detail}">
          <a href="#">
            <img v-if="item.thumbnail" :src="item.thumbnail" :alt="item.subject" @error="replaceByDefaultImg">
            <div v-else class="img-empty"></div>
            <ul>
              <li class="title">{{item.subject}}</li>
              <li class="date">{{item.regDate}}</li>
              <li v-if="currentMenu !== 'news'" class="desc" v-html="item.content"></li>
            </ul>
          </a>
        </router-link>
      </div>
    </div>
    <div v-else-if="!notice" class="empty-div">
      데이터가 없습니다.
    </div>

    <button class="more-btn" @click="moreList" v-if="remainingCount > 0">
      {{ moreBtn ? '6개' : remainingCount+'개' }} 더보기
    </button>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

import {htmlDecode, isEmpty} from '@/lib';
export default {
  name: 'ListView',
  data() {
    return {
      notice: {},
      list: [],
      total: 0,
      remainingCount: 0,
      moreBtn: true,
      page: 1,
      limit: 5,
      offset: 0,
    }
  },
  props: ['currentMenu'],
  watch: {
    currentMenu() {
      this.page = 1;
      this.limit = 5;
      this.offset = 0;
      this.notice = {};
      this.list = [];
      this.remainingCount = 0;
      this.getList();
    }
  },
  mounted () {
    this.getList();
  },
  methods: {
    isEmpty,
    async getList() {
      if(this.page > 1) {
        this.limit = 6;
        this.offset = ((this.page-1)*6) -1;
      }

      let apiUrl = ``;
      if(this.currentMenu === 'csrnews') {
        apiUrl = `/notice/news?category=${this.currentMenu}&page=${this.page}&limit=${this.limit}&offset=${this.offset}`;
      }else {
        apiUrl = `/notice/${this.currentMenu}?page=${this.page}&limit=${this.limit}&offset=${this.offset}`;
      }

      if(this.currentMenu === 'news') {
        apiUrl += '&category=C';
      }

      const {data} = await this.$http.get(apiUrl);

      data.data?.map(item => {
        item.subject = htmlDecode(item.subject);
        item.thumbnail = item.thumbnail ? item.thumbnail : '@/assets/img/web/match_bg.png';
        item.regDate = dayjs(item.reg_date).utc().format('YYYY-MM-DD HH:mm:ss');
        item.detail = { id: item.b_id, page: this.currentMenu };

        if(this.currentMenu === 'vod') {
          const highlight = item.highlight.split('/');
          const videoId = highlight[highlight.length-1];
          item.thumbnail = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
          item.subject = item.meet_name + ' ' + item.home_team_name + ' vs ' + item.away_team_name;
          item.regDate = item.game_date + ' ' + item.game_time;
          // item.detail.year = dayjs(item.game_date).format('YYYY');
          item.detail.id = dayjs(item.game_date).format('YYYY') + '_' + item.game_id;
        } else if(this.currentMenu === 'cheer') {
          item.thumbnail = `https://img.youtube.com/vi/${item.youtube_id}/mqdefault.jpg`;
          item.desc = item.lyrics;
          item.detail.id = item.id;
        } else {
          const imgTag = item.content.match(/<img[^<>]*>/i);
          if(imgTag) {
            const src = imgTag[0].match(/src="([^"]*)"/i);
            item.thumbnail = src[1];
          }

          item.content = item.content.replace(/<img[^>]*>/g, '');
          item.content = item.content.replace(/<br \/>/g, '');
        }
      })

      if (data.data.length) {
        if (this.page === 1) {
          this.notice = data.data[0];
          this.list = data.data.slice(1);
        } else {
          this.list.push(...data.data);
        }
      } else {
        this.notice = {};
        this.list = [];
      }

      this.total = data.total;
      this.remainingCount = this.total-(this.list.length+1);
      this.moreBtn = this.remainingCount >= 5;
    },
    moreList() {
      if (this.remainingCount !== 0) {
        this.page++;
        this.getList();
      } else {
        alert('더 이상 게시글이 없습니다.');
      }
    },

    replaceByDefaultImg(e) {
      e.target.src = require('@/assets/img/board_default.png');
    }
  }
}
</script>
